import i18n from '@/localization/i18n';

export const TRANSLATION_CONST = '_c2g_country_lang';
export const getLocale = (countryFirst: boolean = true, separator: string = '-') => {
  const localeString = i18n.locale;
  if (!countryFirst) {
    return separator !== '-' ? localeString.replace('-', separator) : localeString;
  }

  const language = localeString.substr(0, 2);
  const country = localeString.substr(3, 5);

  return `${country.toUpperCase()}${separator}${language.toLowerCase()}`;
};

export const t = (translationKey: string, options: { [key: string]: string } = { locale: '' }) => {
  let locale = i18n.locale;
  if (options.locale) {
    locale = options.locale;
    delete options.locale;
  }

  return String(i18n.t(translationKey, locale, options));
};
